import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// 🔹 문의사항 목록 조회
export const fetchQnaList = async (token) => {
  const response = await axios.get(`${API_BASE_URL}/qna`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

// 🔹 문의사항 상세 조회
export const fetchQnaDetail = async (id, token) => {
  const response = await axios.get(`${API_BASE_URL}/qna/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

// 🔹 답변 등록 (POST /qna/reply)
export const postQnaReply = async (id, content, token) => {
  const response = await axios.post(
    `${API_BASE_URL}/qna/reply`,
    { id, content },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};
